export default __webpack_public_path__ + "static/media/pantry2-before1-768w.bd030760.webp";